import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheWorldAtYourFingertips from "./sections/TheWorldAtYourFingertips";
import TheGalleryOfDigitalExcellence from "./sections/TheGalleryOfDigitalExcellence";
import OurExpertise from "./sections/OurExpertise";
import PerfectItinerarySuggestions from "./sections/PerfectItinerarySuggestions";
import GuestStories from "./sections/GuestStories";
import HolDirDenUnbegrenztenTurbo from "./sections/HolDirDenUnbegrenztenTurbo";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheWorldAtYourFingertips />
      <TheGalleryOfDigitalExcellence />
      <OurExpertise />
      <PerfectItinerarySuggestions />
      <GuestStories />
      <HolDirDenUnbegrenztenTurbo />
      <Footer />
    </div>;
}